import { render, staticRenderFns } from "./ClientDelete.vue?vue&type=template&id=416f127e&scoped=true&"
import script from "./ClientDelete.vue?vue&type=script&lang=js&"
export * from "./ClientDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416f127e",
  null
  
)

export default component.exports